<div class="eliminados-container">

  @if(!loaded) {
  <!-- Estado inicial: no se consulta Firestore hasta que el usuario lo solicite -->
  <div class="eliminados-cta">
    <i class="pi pi-database"></i>
    <p class="m-0">{{ 'DELETED.CTA_HINT' | translate }}</p>
    <p-button [label]="'DELETED.LOAD' | translate" icon="pi pi-search" (onClick)="cargar()" [loading]="loading" />
  </div>
  } @else {
  <div class="eliminados-toolbar">
    <span class="eliminados-count">{{ 'DELETED.COUNT' | translate:{ count: rows.length } }}</span>
    <p-button icon="pi pi-refresh" [label]="'DELETED.REFRESH' | translate" severity="secondary"
      styleClass="p-button-text" (onClick)="recargar()" [disabled]="loading" />
  </div>

  @if(rows.length > 0) {
  <div class="eliminados-card">
    <p-table [value]="rows" [scrollable]="true" scrollHeight="420px" [tableStyle]="{ 'min-width': '40rem' }"
      class="tabla-eliminados">
      <ng-template pTemplate="header">
        <tr>
          <th>{{ 'DELETED.COL_DELETED_AT' | translate }}</th>
          <th>{{ 'DELETED.COL_DELETED_BY' | translate }}</th>
          <th class="text-center">{{ 'DELETED.COL_TYPE' | translate }}</th>
          <th>{{ 'DELETED.COL_CONCEPT' | translate }}</th>
          <th class="text-center">{{ 'DELETED.COL_AMOUNT' | translate }}</th>
          <th class="text-center">{{ 'DELETED.COL_ACTIONS' | translate }}</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-row>
        <tr [class.eliminados-row--restored]="isRestored(row)">
          <td>{{ formatFecha(row.eliminadoEn) }}</td>
          <td>
            <span class="deleted-author"><i class="pi pi-user"></i> {{ row.eliminadoPorName || '—' }}</span>
          </td>
          <td class="text-center">
            <p-tag [value]="getTipo(row)" [severity]="getTipoSeverity(row)" />
          </td>
          <td>{{ getConcepto(row) }}</td>
          <td class="text-center" [ngClass]="{ 'text-danger': getTipoSeverity(row) === 'danger' }">
            {{ getMonto(row) | missionMoney }}
          </td>
          <td class="text-center">
            <div class="eliminados-actions">
              @if (isRestored(row)) {
              <p-tag [value]="'DELETED.RESTORED_TAG' | translate" severity="success" />
              }
              <p-button icon="pi pi-eye" styleClass="p-button-text p-button-rounded"
                [pTooltip]="'DELETED.TOOLTIP_VIEW' | translate" tooltipPosition="left"
                (onClick)="openDetail(row)" />
              @if (canRestoreRow(row)) {
              <p-button icon="pi pi-replay" styleClass="p-button-text p-button-rounded p-button-success"
                [pTooltip]="'DELETED.TOOLTIP_RESTORE' | translate" tooltipPosition="left"
                [loading]="restoringId === row.id"
                (onClick)="requestRestore(row)" />
              }
            </div>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>

  @if(hasMore) {
  <div class="text-center mt-3">
    <p-button [label]="'DELETED.LOAD_MORE' | translate" icon="pi pi-angle-down" severity="secondary"
      styleClass="p-button-text" (onClick)="cargarMas()" [loading]="loading" />
  </div>
  }
  } @else {
  <div class="eliminados-empty">
    <i class="pi pi-inbox"></i>
    <span>{{ 'DELETED.EMPTY' | translate }}</span>
  </div>
  }
  }

  <!-- Detalle del registro eliminado -->
  <p-dialog [(visible)]="detailVisible" [modal]="true" [draggable]="false" [dismissableMask]="true"
    [style]="{ width: '600px' }" [focusOnShow]="false" appendTo="body" [baseZIndex]="10001"
    styleClass="eliminado-detail-dialog" (onHide)="closeDetail()">
    <ng-template pTemplate="header">
      <div class="detail-header">
        <span class="detail-header-icon"><i class="pi pi-trash"></i></span>
        <div class="d-flex flex-column">
          <span class="detail-header-title">{{ 'DELETED.DETAIL_TITLE' | translate }}</span>
          @if(selected) {
          <span class="detail-header-subtitle">{{ getConcepto(selected) }}</span>
          }
        </div>
      </div>
    </ng-template>

    @if(selected) {
    <div class="detail-meta">
      <div class="detail-meta-item">
        <span class="detail-meta-label">{{ 'DELETED.COL_DELETED_AT' | translate }}</span>
        <span class="detail-meta-value">{{ formatFecha(selected.eliminadoEn) }}</span>
      </div>
      <div class="detail-meta-item">
        <span class="detail-meta-label">{{ 'DELETED.COL_DELETED_BY' | translate }}</span>
        <span class="detail-meta-value">{{ selected.eliminadoPorName || '—' }}</span>
      </div>
      @if (isRestored(selected)) {
      <div class="detail-meta-item">
        <span class="detail-meta-label">{{ 'DELETED.RESTORED_TAG' | translate }}</span>
        <span class="detail-meta-value">{{ formatFecha(selected.restauradoEn) }} · {{ selected.restauradoPorName || '—' }}</span>
      </div>
      }
    </div>

    <div class="detail-section-title">{{ 'DELETED.SNAPSHOT_TITLE' | translate }}</div>
    <div class="detail-snapshot">
      @for(entry of getSnapshotEntries(); track entry.key) {
      <div class="detail-snapshot-row">
        <span class="detail-snapshot-key">{{ entry.key }}</span>
        <span class="detail-snapshot-value">{{ entry.value }}</span>
      </div>
      }
    </div>

    @if(selectedHistorial.length > 0) {
    <div class="detail-section-title">{{ 'DELETED.HISTORY_TITLE' | translate }}</div>
    <ul class="detail-timeline">
      @for(h of visibleSelectedHistorial; track $index) {
      <li class="detail-timeline-item" [ngClass]="{
        'is-create': h.action === 'create',
        'is-update': h.action === 'update',
        'is-restore': h.action === 'restore'
      }">
        <span class="detail-timeline-dot">
          <i class="pi" [ngClass]="h.action === 'create' ? 'pi-plus' : (h.action === 'restore' ? 'pi-replay' : 'pi-pencil')"></i>
        </span>
        <div class="detail-timeline-content">
          <div class="d-flex justify-content-between align-items-center">
            <span class="fw-semibold">
              {{ historyActionKey(h.action) | translate }}
            </span>
            <small class="text-muted">{{ h.fecha }}</small>
          </div>
          <div class="detail-timeline-author"><i class="pi pi-user"></i> {{ h.byName }}</div>
          @if(h.resumen) {
          <div class="detail-timeline-resumen">{{ h.resumen }}</div>
          } @else if(h.campos?.length) {
          <div class="detail-timeline-campos">
            @for(campo of h.campos; track campo) {
            <span class="detail-chip">{{ campo }}</span>
            }
          </div>
          }
        </div>
      </li>
      }
    </ul>
    @if (hasMoreSelectedHistorial) {
    <div class="historial-load-more">
      <span class="historial-showing text-muted small">
        {{ 'COMMON.HISTORY_SHOWING' | translate:{ visible: historialVisibleCount, total: selectedHistorial.length } }}
      </span>
      <p-button [label]="'COMMON.HISTORY_LOAD_MORE' | translate" icon="pi pi-chevron-down"
        severity="secondary" styleClass="p-button-text p-button-sm" (onClick)="loadMoreHistorial()"></p-button>
    </div>
    }
    }
    }

    <ng-template pTemplate="footer">
      @if (selected && canRestoreRow(selected)) {
      <p-button [label]="'DELETED.RESTORE' | translate" icon="pi pi-replay" severity="success"
        [loading]="restoringId === selected.id" (onClick)="requestRestore(selected)" />
      }
      <p-button [label]="'COMMON.CLOSE' | translate" icon="pi pi-times" severity="secondary"
        styleClass="p-button-text" (onClick)="closeDetail()" />
    </ng-template>
  </p-dialog>

</div>
